import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AnalyticsEvent, PAGE_CONTEXT } from '@mode/shared/util-segment';

import { FileExportsUiDrawerComponent } from '@mode/file-exports/ui-drawer';
import { ExplorationsFileExportsComponent } from './+ui/explorations-file-exports/explorations-file-exports.component';

@NgModule({
  declarations: [ExplorationsFileExportsComponent],
  imports: [CommonModule, FileExportsUiDrawerComponent],
  providers: [{ provide: PAGE_CONTEXT, useValue: AnalyticsEvent.SubContext.Exploration }],
  exports: [ExplorationsFileExportsComponent],
})
export class ExplorationsShellModule {}
